import { render } from "./FareModality.vue?vue&type=template&id=11ae5e32"
import script from "./FareModality.vue?vue&type=script&lang=js"
export * from "./FareModality.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__